export function getInContextPrompt (countableType, countableId, countableName) {
    if (!countableId) {
        return `Provide clear, data-focused answers about adoption, usage patterns, and trends across ${countableType}s.`;
    }

    switch (countableType) {
        case 'page':
            return getPagePrompt(countableId, countableName);
        case 'feature':
            return getFeaturePrompt(countableId, countableName);
        case 'visitor':
            return visitorPrompt(countableId, countableName);
        case 'account':
            return accountPrompt(countableId, countableName);
        case 'trackEvent':
            return trackEventPrompt(countableId, countableName);
        default:
            throw new Error(`Unsupported countable type: ${countableType}`);
    }
}

function getPagePrompt (countableId, countableName) {
    return `Provide clear, data-focused answers about adoption, usage patterns, and trends for the following page: @{{"id":"${countableId}", "type": "page", "text": "${countableName}"}}`;
}

function getFeaturePrompt (countableId, countableName) {
    return `Provide clear, data-focused answers about adoption, usage patterns, and trends for the following feature: @{{"id":"${countableId}", "type": "feature", "text": "${countableName}"}}`;
}

function visitorPrompt (countableId, countableName) {
    return `Provide clear, data-focused answers about adoption, usage patterns, and trends for the following visitor: @{{"id":"${countableId}", "type": "visitor", "text": "${countableName}"}}`;
}

function accountPrompt (countableId, countableName) {
    return `Provide clear, data-focused answers about adoption, usage patterns, and trends for the following account: @{{"id":"${countableId}", "type": "account", "text": "${countableName}"}}`;
}

function trackEventPrompt (countableId, countableName) {
    return `Provide clear, data-focused answers about adoption, usage patterns, and trends for the following track event: @{{"id":"${countableId}", "type": "trackEvent", "text": "${countableName}"}}`;
}